<template>
  <div class="fcx-detail">
    <h4>
      Migration & Extraction <ExternalLink class="btn btn-link m-0 p-0" link="https://www.foodpackagingforum.org/fccmigex"> <i class="fas fa-external-link-alt" /></ExternalLink>
    </h4>
    <div class="row">
      <div class="col-12 mb-2">
        <h6>Measured transferring from FCMs? - {{ IsDetected | boolToSpeech }}</h6>
        <div class="row">
          <div class="col-12 col-md-6 mb-2">
            <strong>Primary Material</strong>
            <br>
            <ul>
              <li v-if="!HasPrimaryMaterials">
                no material available
              </li>
              <li
                v-for="(item,index) in PrimaryFCMs"
                :key="index"
              >
                {{ item }}
              </li>
            </ul>
          </div>
          <div class="col-12 col-md-6 mb-2">
            <strong>Secondary Material</strong>
            <br>
            <ul>
              <li v-if="!HasSecondaryMaterials">
                no material available
              </li>
              <li
                v-for="(item,index) in SecondaryFCMs"
                :key="index"
              >
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!--
      <div class="col-12 col-md-6 mb-2">
        <h6>Measured in the human body? - N/A</h6>
      </div>
      -->
      <div class="col-12 mb-3">
        <h6>Statistics</h6>
        <cite>coming soon</cite>
      </div>

      <div class="col-12 mb-2">
        <h6>Sources</h6>
        <div v-if="!localInput.extractions.migex">
          no sources available
        </div>
        <table v-else class="table table-responsive table-striped table-bordered">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col" style="min-width: 250px">Name</th>
              <th scope="col" style="min-width: 250px">Authors</th>
              <th scope="col">Journal</th>
              <th scope="col">Year</th>
              <th scope="col">URI</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(col, index) in MigexSources"
              :key="index"
            >
              <th scope="row">{{ index }}</th>
              <td>{{ col.name }}</td>
              <td>{{ col.authors }}</td>
              <td>{{ col.journalTitle }}</td>
              <td>{{ col.publicationDate }}</td>
              <td><ExternalLink :link="col.uri"/></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="col-12 text-sm-left mt-3">
        For more in depth information, visit: <ExternalLink link="https://www.foodpackagingforum.org/fccmigex" />.
      </div>
    </div>
  </div>
</template>

<script>
//import { Bar } from 'vue-chartjs';

//import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
//ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)


import ExternalLink from "@/components/Fcx/ExternalLink.vue";

export default {
  name: "DetailResearch",
  components: {
    ExternalLink

  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      primaryFCMs: [],
      secondaryFCMs: [],
      detected: false
    };
  },
  computed: {
    localInput: {
      get() {
        // transform if string => obj
        return this.value;
      },
      set(localInput) {
        this.$emit("input", localInput);
      }
    },
    Extractions() {
      return this.localInput.extractions;
    },
    MigexSources() {
      return this.Extractions?.migex?.sources || [];
    },
    PrimaryFCMs: {
      get() {
        return this.Extractions?.migex?.primaryMaterials || [];
      }
    },
    SecondaryFCMs: {
      get() {
        return this.Extractions?.migex?.secondaryMaterials || [];
      }
    },
    HasPrimaryMaterials() {
      return this.PrimaryFCMs && this.PrimaryFCMs.length > 0;
    },
    HasSecondaryMaterials() {
      return this.SecondaryFCMs && this.SecondaryFCMs.length > 0;
    },
    IsDetected: {
      get() {
        return this.HasPrimaryMaterials || this.HasSecondaryMaterials;
      }
    },
  },
  mounted() {}
};
</script>

<style scoped>
table {
  font-size: 12px;
}
</style>
